import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";
import { MAX_PAGE_CONTENT_WIDTH } from "../../../constants";

const styles: StyleRulesCallback = ({ breakpoints, palette, spacing: { unit } }) => ({
  attributesContainer: {
    "& > img:nth-child(even)": {
      marginBottom: unit * 2
    },
    "& > img:nth-child(odd)": {
      marginBottom: unit * 4
    },
    background: palette.background.default,
    display: "flex",
    flexDirection: "column",
    flexGrow: 1
  },
  buttonContainer: {
    display: "none",
    flexGrow: 1,
    textAlign: "right",
    [breakpoints.up("sm")]: {
      display: "initial"
    }
  },
  containerColumn: {
    margin: "0 auto",
    maxWidth: `${MAX_PAGE_CONTENT_WIDTH}px`,
    padding: unit * 3,
    width: "100%"
  },
  headerContainer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between"
  },
  infoContainer: {
    "& > :first-child": {
      marginRight: unit * 3
    }
  }
});

export type Styles = WithStyles<typeof styles>;
const withStyles = withStylesCb(styles);

export { styles, withStyles };
